import { useState } from "react";
import { useSelector } from "react-redux";

import useSWR, { useSWRConfig} from "swr";

import { Box, Button, ButtonGroup, Stack } from "@mui/material"

import api from "../../../api";
import { Add, Close } from "@mui/icons-material";

const AddToLibrary = ({ junctionTable, filter, addPayload, removePayload }) => {
    const { mutate } = useSWRConfig();

    const retailer = useSelector(state => state.retailer);
    
    const [loading, setLoading] = useState(false);

    const { data: hits } = useSWR(!loading && junctionTable ? {
        url: `/${junctionTable}`,
        filter,
    } : null);

    const actionOptions = [
        ...(
            !!!hits || !!hits?.length ? [] : [
                {
                    key: 'Add to Library',
                    content: 'Add to Library ',
                    icon: (<Add color="success" />),
                    onClick: () => {
                        addToLibrary(junctionTable, addPayload);
                    },
                },
            ]
        ),
        ...(
            !!!hits || !!!hits?.length ? [] : [
                {
                    key: 'Remove from Library',
                    content: 'Remove from Library ',
                    icon: (<Close color="error" />),
                    onClick: () => {
                        removeFromLibrary(junctionTable, removePayload);
                    },
                },
            ]
        ),
    ];

    const addToLibrary = async (junctionTable, payload) => {
        setLoading(true);
        await api.addToJunction(junctionTable, payload);
        setLoading(false);
        mutate();
    }

    const removeFromLibrary = async (junctionTable, payload) => {
        setLoading(true);
        await api.deleteFromJunction(junctionTable, payload);
        setLoading(false);
        mutate();
    }

    return (
        <Box>
            <Stack
                spacing={0.5}
            >
                <ButtonGroup>
                    {
                        actionOptions.map((option) => (
                            <Button
                                key={option.key}
                                color={option.color}
                                disabled={option.disabled}
                                onClick={option.onClick}
                                variant="outlined"
                                size={'small'}
                                sx={{
                                    borderRadius: {
                                        xs: 0,
                                        md: '2rem',
                                    },
                                    color: '#000',
                                    background: '#efeeee',
                                    borderColor: '#e0e0e0',
                                }}
                                endIcon={option.icon}
                            >
                                {option.content}
                            </Button>
                        ))
                    }
                </ButtonGroup>
            </Stack>
        </Box>
    )
}

export default AddToLibrary